import SectionHeading from "@/components/base/SectionHeading";
import { domesticPicks } from "@/mocks/content";

export default function DomesticPicks() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <SectionHeading
        id="domestic"
        eyebrow="Chinese Dramas"
        title="国产剧：贴近本土语境的题材集合"
        description="国产剧在古装、年代与现实题材上积累较多，人物关系与情感表达往往是重点。下面按题材方向挑选了几部具有代表性的作品，方便你对照了解各自的特点。"
      />

      <div className="mt-10 md:mt-12 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
        {domesticPicks.map((item) => (
          <article
            key={item.id}
            className="group rounded-lg overflow-hidden border border-background-200 bg-background-100 transition-colors hover:border-accent-300"
          >
            <div className="w-full h-52 sm:h-60 overflow-hidden bg-background-200">
              <img
                src={item.image}
                alt={`${item.title} 剧照`}
                title={`${item.title} 剧照`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5 md:p-6">
              <div className="flex items-center justify-between gap-3">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
                <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-[11px] whitespace-nowrap">
                  {item.meta}
                </span>
              </div>
              <p className="mt-1 text-xs text-foreground-500">
                {item.original} · {item.year}
              </p>
              <p className="mt-3 text-sm leading-7 text-foreground-600">{item.desc}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}